module.exports = __webpack_public_path__ + "img/zm.zm864bd08.svg";